<template>
  <div class="confirm-delete-file">
    <div class="confirm-delete-file__header">
      <span></span>
      <IconTrash2Medium class="confirm-delete-file__header__icon" />
      <button class="confirm-delete-file__header__close-button" @click="emits('closeOverlay')">
        <IconXCircleMedium class="confirm-delete-file__header__close-button__icon" />
      </button>
    </div>
    <div class="confirm-delete-file__content">
      <p class="confirm-delete-file__content__title">{{ t('general__text__delete') }}</p>
      <p class="confirm-delete-file__content__text">{{ t('general__text__delete-observe') }}</p>
    </div>
    <div class="confirm-delete-file__footer">
      <ButtonText
        class="confirm-delete-file__footer__button cancel"
        :buttonText="t('general__text__cancel')"
        @onClicked="emits('closeOverlay')"
      />
      <ButtonPrimary
        class="confirm-delete-file__footer__button"
        :buttonText="buttonText"
        @onClicked="confirmDelete()"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import IconTrash2Medium from '@/design-system/assets/icons/IconTrash2Medium.vue'
import IconXCircleMedium from '@/design-system/assets/icons/IconXCircleMedium.vue'
// emits
interface EMITS {
  (e: 'closeOverlay'): void
  (e: 'confirmDelete'): void
}
const emits = defineEmits<EMITS>()
defineProps<{
  buttonText: string
}>()
const { t } = useI18n()
function confirmDelete() {
  emits('confirmDelete')
  emits('closeOverlay')
}
</script>
<style lang="scss" scoped>
@use '@/design-system/design-tokens/variables.scss';
@use '@/design-system/design-tokens/font-mixins';
.confirm-delete-file {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 8px;
    &__text {
      color: variables.$color-greyscale-content;
      margin: 0;
      @include font-mixins.desktop-bold-paragraph;
    }
    &__title {
      color: variables.$color-greyscale-content;
      margin: 0;
      @include font-mixins.desktop-bold-h4;
    }
  }
  &__footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 24px;
    height: 48px;
    margin-top: 24px;
    &__button {
      display: flex;
      width: 100%;
      &.cancel {
        color: variables.$color-primary;
      }
    }
  }
  &__header {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 8px;
    &__close-button {
      all: unset;
      height: 40px;
      margin-left: auto;
      width: 40px;
      &:focus {
        outline: revert;
      }
      &__icon {
        color: variables.$color-primary;
        cursor: pointer;
      }
    }
    &__icon {
      color: variables.$color-error;
      margin: auto;
      margin-top: 8px;
      min-width: 48px;
      height: 48px;
      width: 48px;
    }
  }
}
</style>
